import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {StorageService} from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import {FilterPipe} from 'ngx-filter-pipe';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {Title} from '@angular/platform-browser';
import {AppConfigService} from '../../../Services/app-config.service';
import {DecimalNewPipe} from '../../common/DecimalNewPipe';
import {DatePipe} from '@angular/common';
import {ResponseModel} from '../../../DataModels/response-model';
// import {Subject} from 'rxjs';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../Services/ngbpagination-config.service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {PaymentDocumentService} from '../../../Services/payment-document.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {PermissionsService} from '../../../Services/permissions.service';
import {ToWords} from '../../../Services/ToWordsService/ToWords';
import {Mutex, MutexInterface} from 'async-mutex';
import {HttpErrorResponse} from '@angular/common/http';
import {take, tap} from 'rxjs/operators';
import {firstValueFrom} from 'rxjs';
import {EmailModel} from '../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css'],
  standalone: false
})
export class PaymentListComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {
  private locks: Map<string, MutexInterface>;
  private printingReceipt = false;
  emailing = false;

  constructor(
    private route: ActivatedRoute,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private decimalPipe: DecimalNewPipe,
    private datePipe: DatePipe,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    public confirmDialogService: ConfirmDialogService,
    private paymentDoc: PaymentDocumentService,
    private permissionsService: PermissionsService
  ) {
    super();
    this.locks = new Map();

    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();

    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.vm.type = params.type;
      this.vm.subLedger = params.type; // subledger same as type;
      // this.ngOnInit();
    });
  }

  get hasEditReceivablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivablePayments');
  }

  get hasEditPayablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPayablePayments');
  }

  vm: any = {};
  buttonsDisabled: any;
  paymentCount = 0;
  isLoaded = false;

  checkAll = false;
  selectedRecords = [];

  // Removed legacy angular-datatables settings and trigger (now unused with shared DataTableComponent)


  batchType = '';
  mutexVar = '123456';

  // Email support
  reportDataToSendInEmail: EmailModel = new EmailModel();
  // Guards
  private printingPaidCopy = false;

  ngOnInit() {
    this.restorePagerState();
    // this.router.navigate([this.router.url], { relativeTo: this.route, skipLocationChange: false }).then();
    // Restore pager from enhanced per-tab cache using a normalized key (include subLedger when available)
    // this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
    this.vm.list = [];
    // this.vm.type = params.type;
    // this.vm.subLedger = params.type; // subledger same as type;
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.batchesHidden = !this.vm.Preferences.ShowBatches;
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    // batch type for batch new post modal
    if (this.vm.subLedger == 'ap') {
      this.batchType = '5';
      this.vm.batchType = '5';
    } else {
      this.batchType = '3';
      this.vm.batchType = '3';
    }

    if (
      !this.vm.permissions.EditReceivablePayments &&
      !this.vm.permissions.ViewReceivablePayments &&
      !this.vm.permissions.EditPayablePayments &&
      !this.vm.permissions.ViewPayablePayments &&
      !this.vm.permissions.Admin
    ) {
      document.location.href = '/';
    }

    this.getTableData('bank', '?state=active&pageNumber=0&pageSize=999999', (value) => {
      this.vm.bank = value.Data;
    });

    this.getTableData('company', '?state=active&pageNumber=0&pageSize=999999', (value) => {
      this.vm.company = value.Data;
    });

    this.getTableData('entity', '?state=active&pageNumber=0&pageSize=999999', (value) => {
      this.vm.entity = value.Data;
    });

    this.getTableData('check_stock', '?state=active&pageNumber=0&pageSize=999999', (value) => {
      this.vm.checkStock = value.Data;
    });

    // console.log('type: ' + this.vm.type);
    if (this.vm.type === 'ar') {
      this.vm.reverse = 1;
    } else {
      this.vm.reverse = -1;
    }

    this.vm.owingSelected = this.vm.totalSelected = 0;
    this.vm.paymentToDateOpen = this.vm.paymentFromDateOpen = false;
    this.vm.unappliedOnly = false;
    this.vm.notPrintedOnly = false;

    this.vm.paymentFilter = {
      text: '',
      sort: 'audit_sequence',
      ascending: true,
    };

    this.vm.paymentSearch = '';
    this.vm.paymentToDate = '';
    this.vm.paymentFromDate = '';
    this.vm.unappliedOnly = '';
    this.vm.notPrintedOnly = '';
    this.vm.batchId = '';
    this.vm.searchHidden = false;
    this.init();
    // });
  }

  async printArReceipt(id: any) {
    if (this.printingReceipt) {
      return;
    }
    this.printingReceipt = true;
    try {
      const paymentId = String(id);
      // Load unified entry for this payment
      const entry = await this.paymentDoc.getEntry(paymentId);
      const e: any = (entry && (entry as any).Data) ? (entry as any).Data : entry;
      const item = e?.item || e || {};
      const header = item?.header || item?.t_header || {};
      const detail = Array.isArray(item?.detail) ? item.detail : (Array.isArray(e?.detail) ? e.detail : []);
      const applied = Array.isArray(item?.applied) ? item.applied : (Array.isArray(e?.applied) ? e.applied : []);

      // Ensure we have company and billTo address lists; for list context, fetch Bill To addresses by entity
      const company = this.vm?.company || [];
      let entityAddresses = this.vm?.entityAddress || [];
      try {
        const entityId = header?.entity_id || header?.vendor_id || header?.customer_id || item?.entity_id;
        if ((!entityAddresses || entityAddresses.length === 0) && entityId) {
          const resp: any = await firstValueFrom(this.tableDataService.getData('entity_address/addresses', `?type=bill&entity_id=${entityId}`));
          const data = (resp && (resp.Data || resp.data)) ? (resp.Data || resp.data) : resp;
          if (Array.isArray(data)) {
            entityAddresses = data;
          }
        }
      } catch {
        // ignore, fallback to empty
      }

      // Build VM following the receipt builder expectations
      const mappedVm: any = {
        item: {
          header,
          detail,
          applied,
        },
        company: company,
        billToAddress: entityAddresses,
        shipToAddress: entityAddresses,
        subLedger: 'ar',
        type: 'ar',
        totals: {
          originalOwed: undefined, // unknown in list; builder hides when not provided
          paymentAmount: Math.abs(Number(detail?.[0]?.amount || 0)),
          totalApplied: Math.abs(Number((applied || []).reduce((s: number, a: any) => s + Number(a?.applied_amount || 0), 0))),
        },
      };

      const html = this.paymentDoc.buildPrintHtml(mappedVm, 'receipt');
      await this.paymentDoc.printHtml(html);
    } catch (err) {
      console.error('Failed to print AR receipt from list', err);
      this.notification.showErrorToast($localize`:Unable to print receipt@@unableToPrintReceipt:Unable to print receipt`);
    } finally {
      this.printingReceipt = false;
    }
  }

  /**
   * Open Send Email modal to email a Receipt for AR payments from the list.
   */
  async email(id: any) {
    if (this.emailing) {
      return;
    }
    this.emailing = true;
    try {
      const paymentId = String(id);
      // Load unified entry for this payment
      const entry = await this.paymentDoc.getEntry(paymentId);
      const e: any = (entry && (entry as any).Data) ? (entry as any).Data : entry;
      const item = e?.item || e || {};
      const header = item?.header || item?.t_header || {};
      const detail = Array.isArray(item?.detail) ? item.detail : (Array.isArray(e?.detail) ? e.detail : []);
      const applied = Array.isArray(item?.applied) ? item.applied : (Array.isArray(e?.applied) ? e.applied : []);

      if (this.vm.type === 'ar') {
        // Ensure Bill To addresses for the entity
        let entityAddresses = this.vm?.entityAddress || [];
        try {
          const entityId = header?.entity_id || header?.vendor_id || header?.customer_id || item?.entity_id;
          if ((!entityAddresses || entityAddresses.length === 0) && entityId) {
            const resp: any = await firstValueFrom(this.tableDataService.getData('entity_address/addresses', `?type=bill&entity_id=${entityId}`));
            const data = (resp && (resp.Data || resp.data)) ? (resp.Data || resp.data) : resp;
            if (Array.isArray(data)) {
              entityAddresses = data;
            }
          }
        } catch {
        }

        // Build VM for receipt HTML
        const mappedVm: any = {
          item: {header, detail, applied},
          company: this.vm?.company,
          billToAddress: entityAddresses,
          shipToAddress: entityAddresses,
          subLedger: 'ar',
          type: 'ar',
          totals: {
            paymentAmount: Math.abs(Number(detail?.[0]?.amount || 0)),
            totalApplied: Math.abs(Number((applied || []).reduce((s: number, a: any) => s + Number(a?.applied_amount || 0), 0))),
          },
        };

        const html = this.paymentDoc.buildPrintHtml(mappedVm, 'receipt');

        // Build EmailModel expected by Send Email modal
        const emailObj = new EmailModel();
        emailObj.header_id = id;
        emailObj.entity_id = String(header?.entity_id || '');
        emailObj.Subject = `Receipt #${header?.number ?? ''}`;
        emailObj.FileName = `Receipt-${header?.number ?? id}.pdf`;
        emailObj.pdfHtml = html;
        emailObj.convert_attachment_to = 'pdf';
        this.reportDataToSendInEmail = emailObj;
      } else {
        // AP: Email a Paid watermark check copy when payment has been applied
        const row = (Array.isArray(this.vm?.list) ? this.vm.list : []).find((r: any) => String(r?.id) === paymentId) || {};
        const appliedTotal = Math.abs(Number(row?.payment_applied_total || 0));
        if (appliedTotal === 0) {
          this.notification.showWarningToast($localize`:No applied amount@@noAppliedAmount:No applied amount to email`);
          return;
        }
        // Resolve company/bank and check stock similar to preview flow
        const tempCompany = (this.FilterObject(this.vm.company, {id: row.company_id}, true)[0]) || {};
        const tempBank = (this.FilterObject(this.vm.bank, {id: row.bank_id}, true)[0]) || {};
        const checkStock = (this.FilterObject(this.vm.checkStock, {id: tempBank.stock_id}, true)[0]) || {};

        // Build single check object
        const words = new ToWords();
        const paymentAmountAbs = Math.abs(Number(row?.detail_total || 0));
        const amountForWords = (this.vm.subLedger === 'ap') ? (row?.detail_total * -1) : row?.detail_total;
        const amountInWords = words.convert(amountForWords || 0, {currency: true});

        const check: any = {
          number: header?.number,
          date: header?.header_date || row?.header_date,
          detail_total: row?.detail_total,
          payment_applied_total: row?.payment_applied_total,
          amount: (this.vm.subLedger === 'ap') ? (row?.payment_applied_total * -1) : row?.payment_applied_total,
          amountInWords,
          entity_name: row?.entity_name,
          payeeName: row?.entity_name,
          address_1: row?.address_1,
          address_2: row?.address_2,
          company_id: row?.company_id,
          bank_id: row?.bank_id,
          bankName: tempBank?.check_name,
          bankAddress1: tempBank?.address_1,
          bankAddress2: [tempBank?.city, tempBank?.state].filter(Boolean).join(', '),
          accountNumber: tempBank?.account_number,
          transitNumber: tempBank?.transit_number,
          institutionNumber: tempBank?.institution_number,
          companyName: tempCompany?.name,
          companyDBA: tempCompany?.dba,
          companyAddress1: tempCompany?.address_1,
          companyAddress2: [tempCompany?.city, tempCompany?.state, tempCompany?.zip].filter(Boolean).join(', '),
          companyPhone: tempCompany?.phone,
          // Stub fields
          paymentAmount: paymentAmountAbs,
          totalPaid: appliedTotal,
        };
        // Attach applied list for stub
        check.applied = applied;

        const apVm: any = {
          check: [check],
          printLayout: {checkStock},
          company: this.vm?.company,
          applied,
          paymentAmount: paymentAmountAbs,
          totalPaid: appliedTotal,
        };

        const html = this.paymentDoc.buildApCheckHtml(apVm);

        const emailObj = new EmailModel();
        emailObj.header_id = id;
        emailObj.entity_id = String(header?.entity_id || header?.vendor_id || '');
        emailObj.Subject = `Paid Check Copy #${header?.number ?? ''}`;
        emailObj.FileName = `Paid-Check-Copy-${header?.number ?? id}.pdf`;
        emailObj.pdfHtml = html;
        emailObj.convert_attachment_to = 'pdf';
        this.reportDataToSendInEmail = emailObj;
      }

      // Open the modal
      const el = document.getElementById('sendEmailModal');
      if (el) {
        const modal = Modal.getOrCreateInstance(el);
        modal.show();
      }
    } catch (err) {
      console.error('Failed to prepare email from list', err);
      this.notification.showErrorToast($localize`:Unable to prepare email@@unableToPrepareEmail:Unable to prepare email`);
    } finally {
      this.emailing = false;
    }
  }

  /**
   * AP: Print a PAID watermark check copy directly from the list when the row is valid for a check and already printed.
   */
  async printApPaidCopy(id: any) {
    try {
      if (this.vm.type !== 'ap') {
        return;
      }
      if (this.printingPaidCopy) {
        return;
      }
      this.printingPaidCopy = true;

      const paymentId = String(id);
      // Load entry to get header/applied
      const entry = await this.paymentDoc.getEntry(paymentId);
      const e: any = (entry && (entry as any).Data) ? (entry as any).Data : entry;
      const item = e?.item || e || {};
      const header = item?.header || item?.t_header || {};
      const applied = Array.isArray(item?.applied) ? item.applied : (Array.isArray(e?.applied) ? e.applied : []);

      // Find the row in the current list to resolve bank/company and amounts
      const row = (Array.isArray(this.vm?.list) ? this.vm.list : []).find((r: any) => String(r?.id) === paymentId) || {};
      const appliedTotal = Math.abs(Number(row?.payment_applied_total || 0));
      if (appliedTotal === 0) {
        this.notification.showWarningToast($localize`:No applied invoices - cannot print check@@noAppliedCannotPrint:No applied invoices - cannot print check`);
        return;
      }

      // Resolve company/bank/stock
      const tempCompany = (this.FilterObject(this.vm.company, {id: row.company_id}, true)[0]) || {};
      const tempBank = (this.FilterObject(this.vm.bank, {id: row.bank_id}, true)[0]) || {};
      const checkStock = (this.FilterObject(this.vm.checkStock, {id: tempBank.stock_id}, true)[0]) || {};

      // Build check object for Paid Copy
      const words = new ToWords();
      const amountInWords = words.convert(appliedTotal || 0, {currency: true});

      const check: any = {
        number: header?.number || row?.number,
        date: header?.header_date || row?.header_date,
        // On Paid Copy, show applied total as the face amount
        amount: appliedTotal,
        amountInWords,
        entity_name: row?.entity_name,
        payeeName: row?.entity_name,
        address_1: row?.address_1,
        address_2: row?.address_2,
        company_id: row?.company_id,
        bank_id: row?.bank_id,
        bankName: tempBank?.check_name,
        bankAddress1: tempBank?.address_1,
        bankAddress2: [tempBank?.city, tempBank?.state].filter(Boolean).join(', '),
        accountNumber: tempBank?.account_number,
        transitNumber: tempBank?.transit_number,
        institutionNumber: tempBank?.institution_number,
        companyName: tempCompany?.name,
        companyDBA: tempCompany?.dba,
        companyAddress1: tempCompany?.address_1,
        companyAddress2: [tempCompany?.city, tempCompany?.state, tempCompany?.zip].filter(Boolean).join(', '),
        companyPhone: tempCompany?.phone,
        // Stub
        paymentAmount: Math.abs(Number(row?.detail_total || 0)),
        totalPaid: appliedTotal,
      };
      // Attach applied list for stub rendering
      check.applied = applied;

      const apVm: any = {
        check: [check],
        printLayout: {checkStock},
        company: this.vm?.company,
        applied,
        paymentAmount: Math.abs(Number(row?.detail_total || 0)),
        totalPaid: appliedTotal,
      };

      const html = this.paymentDoc.buildApCheckHtml(apVm);
      await this.paymentDoc.printHtml(html);
    } catch (err) {
      console.error('Failed to print AP Paid Copy from list', err);
      this.notification.showErrorToast($localize`:Unable to print check copy@@unableToPrintCheckCopy:Unable to print check copy`);
    } finally {
      this.printingPaidCopy = false;
    }
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Payments @@payments:Payments`);
    // this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // no dtTrigger to clean up anymore
  }



  private getTableData(tableName, params, fun) {
    this.tableDataService.getApiListData(tableName, params).subscribe((result: any) => {
      fun(result);
    });
    // }
  }

  init() {
    if (this.vm.batchId) {
      this.getBatches();
    } else {
      this.search();
    }
  }

  selectAllRows(event: any) {
    if (!event) {
      this.vm.list.forEach((item) => (item.selected = false));
    } else if (event) {
      // this.vm.list.forEach((item) => (item.selected = true));
      this.vm.list.forEach((item) => {
        if (item.locked || item.printed) {
          item.selected = false;
        } else {
          item.selected = true;
        }
      });
    }
    // console.log('all select records: ' + JSON.stringify(this.vm.list));
  }

  selectRow(rec: any, checked: boolean) {
    // console.log('rec val:' + rec + ' - ' + checked);
    if (this.checkAll && rec) {
      this.checkAll = false;
    }
    if (!checked) {
      this.vm.list.forEach((item) => {
        if (item.id === rec) {
          item.selected = false;
        }
      });
    } else if (checked) {
      this.vm.list.forEach((item) => {
        if (item.id === rec && !item.locked && !item.printed) {
          item.selected = true;
        } else if (item.id === rec) {
          // prevent selecting invalid rows (fully applied or nothing applied for AP)
          item.selected = false;
        }
      });
    }
    this.isAllChecked();

    // console.log('single select records' + JSON.stringify(this.vm.list));
  }

  isAllChecked(): boolean {
    const retVal = this.vm.list.every((x) => x.selected === true);
    this.checkAll = retVal;
    return retVal;
  }

  unCheckAll() {
    this.vm.list.forEach((item) => {
      // if (item.selected == true ) {
      item.selected = false;
      // }
    });
    this.checkAll = false;
  }


  // confirmPrintSelected() {
  //   if (this.vm.list.filter((x) => x.selected).length === 0) {
  //     this.notification.showWarningToast('No records selected to print!');
  //     return;
  //   }
  //   let sum = 0;
  //   this.vm.list
  //     .filter((x) => x.selected)
  //     .forEach((x) => {
  //       if (x.payment_applied_total != 0) {
  //         sum += x.payment_applied_total;
  //       }
  //     });
  //
  //   const messages: string[] = [
  //     $localize`:Are you sure you want to Print? @@areyousureyouwanttoprint:Are you sure you want to Print?`,
  //     'Selected Count: ' + this.vm.list.filter((x) => x.selected).length,
  //     +' ' + 'Amount: ' + this.decimalPipe.transform(sum),
  //   ];
  //   this.confirmDialogService.confirmThis(
  //     messages,
  //     () => {
  //       this.printSelected();
  //     },
  //     () => {
  //       this.notification.showSuccessToast($localize`:Print Canceled @@printCanceled:Print Canceled`);
  //     }
  //   );
  // }

  // printSelected() {
  //   // todo do stuff here to print all the checks in the array
  // }

  search() {
    // console.log('searching...');
    this.vm.searching = true;
    this.vm.list = [];
    this.vm.batchId = '';
    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '5';
    } else {
      tempBatchType = '3';
    }

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&batchId=' + (this.vm.batchId ? this.vm.batchId : '');
    paramString += '&search=' + (this.vm.paymentSearch ? this.vm.paymentSearch : '');
    paramString += '&fromDate=' + (this.vm.paymentFromDate ? this.dateFilter.GetDateFormat(this.vm.paymentFromDate) : '');
    paramString += '&toDate=' + (this.vm.paymentToDate ? this.dateFilter.GetDateFormat(this.vm.paymentToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe({
      next: (result: any[]) => {
        this.vm.batches = result;

        paramString = '';
        paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
        paramString += '&batchId=' + (this.vm.batchId ? this.vm.batchId : '');
        paramString += '&search=' + (this.vm.paymentSearch ? this.vm.paymentSearch : '');
        paramString += '&fromDate=' + (this.vm.paymentFromDate ? this.dateFilter.GetDateFormat(this.vm.paymentFromDate) : '');
        paramString += '&toDate=' + (this.vm.paymentToDate ? this.dateFilter.GetDateFormat(this.vm.paymentToDate) : '');
        paramString += '&unappliedOnly=' + (this.vm.unappliedOnly ? 'true' : '');
        paramString += '&notPrintedOnly=' + (this.vm.notPrintedOnly ? 'true' : '');
        paramString += '&numberOfResults=' + (this.vm.paymentNumberOfResults ? this.vm.paymentNumberOfResults : '');
        paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
        paramString += '&pageSize=' + this.pageSize;

        this.tableDataService.getApiListData('PaymentList', '?' + paramString).subscribe({
          next: (result2: ResponseModel) => {
            this.vm.list = result2.Data;
            this.totalRecords = result2.totalRecords;
            this.paginate(false);
            this.paymentCount = result2.totalRecords;
            this.vm.searching = false;
            this.isLoaded = true;
            // this.dataTableFullClear();
            // this.dtTrigger.next(null);
          },
          error: (err: any) => {
            // console.error('Error fetching PaymentList:', err);
            this.vm.searching = false;
          },
          complete: () => {
          }
        });
      },
      error: (err: any) => {
        console.error('Error fetching t_batch:', err);
        this.vm.searching = false;
      },
      complete: () => {
        // console.log('t_batch data fetch completed.');
      }
    });


  }

  filter(filter) {
    this.vm.paymentFilter = Object.assign(this.vm.paymentFilter, filter);
    this.localStorage.StorageSet('paymentFilter', this.vm.paymentFilter);
  }

  getBatchItems(batchId) {
    this.localStorage.StorageSet('batchId', batchId);

    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '5';
    } else {
      tempBatchType = '3';
    }
    this.vm.batchId = batchId;
    this.vm.searching = true;
    // this.vm.tempDescription = 'Batch';
    const obj: any = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true);
    if (obj.length == 0) {
      obj[0] = {description: '', locked: ''};
    }
    this.vm.tempDescription = obj ? obj[0].description : '';
    this.vm.tempBatchLocked = obj ? obj[0].locked : false;
    let paramString = '';
    paramString += 'batchId=' + (this.vm.batchId ? this.vm.batchId : '');
    paramString += '&batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&pageNumber=0';
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('PaymentList', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;

      // this.setList(result);
      // this.convertToNumbers();
      this.vm.searching = false;

      this.totalRecords = result.totalRecords;
      this.paginate(false);
    });
  }

  updateBatchesSelectedInModal(batchId: string) {
    this.getBatchItems(batchId);
    // this.paginate(false);
  }

  getBatches() {
    this.vm.searching = true;
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '5';
    } else {
      tempBatchType = '3';
    }

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    // paramString += '&search=' + ((this.vm.paymentSearch) ? this.vm.paymentSearch : '');
    // paramString += '&fromDate=' + ((this.vm.paymentFromDate) ? this.dateFilter.GetDateFormat(this.vm.paymentFromDate) : '');
    // paramString += '&toDate=' + ((this.vm.paymentToDate) ? this.dateFilter.GetDateFormat(this.vm.paymentToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    // paramString += '&paymentNumberOfResults=' + ((this.vm.paymentNumberOfResults) ? this.vm.paymentNumberOfResults : '');
    // paramString += '&includePosted=' + ((this.vm.includePosted) ? this.vm.includePosted : '');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      if (this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true).length == 1) {
        this.vm.tempDescription = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true)[0].description;
        this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true)[0].locked;
      }
      this.vm.searching = false;
      if (this.vm.batchId) {
        this.getBatchItems(this.vm.batchId);
      }
    });
  }

  newBatch() {
    let newBatch;
    if (this.vm.subLedger == 'ar') {
      newBatch = {type_id: 3};
    } else {
      newBatch = {type_id: 5};
    }

    this.tableDataService.post('t_batch', newBatch).subscribe(
      (item: any) => {
        this.getBatches();
        this.vm.batchId = item.id;
        this.vm.tempDescription = 'Batch';
        this.notification.showSuccessToast($localize`:Batch Added @@batchAdded:Batch Added`);
      },
      (error: { error: { Message: string }; statusText: string }) => {
        this.vm.buttonsDisabled = false;
        let ErrorMsg: string;
        if (typeof error.error.Message != 'undefined') {
          ErrorMsg = error.error.Message;
        } else {
          ErrorMsg = error.statusText;
        }
        console.log(ErrorMsg);
      }
    );
  }

  updateBatch() {
    this.vm.buttonsDisabled = true;
    const changes = {description: this.vm.tempDescription};

    this.tableDataService
      .patch('t_batch', this.vm.batchId, changes)
      .then((item: any) => {
        // this.notification.success(this.vm.tempDescription);
        this.getBatches();
      })
      .catch((msg: string) => {
        this.vm.buttonsDisabled = false;
        console.log(msg);
      });
  }

  postBatch(batchId) {
    this.vm.buttonsDisabled = true;
    const changes = {locked: 'true'};
    this.tableDataService
      .patch('t_batch', batchId, changes)
      .then((item: any) => {
        if (item) {
          // this.notification.success(item.description);
        }
        this.getBatches();
      })
      .catch((msg: string) => {
        this.vm.buttonsDisabled = false;
        console.log(msg);
      });
  }



  confirmDeleteSelected() {
    if (this.vm.list.filter(x => x.selected).length === 0) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }
    const messages: string[] = [
      $localize`:Are you sure you want to Delete? @@areyousureyouwanttodelete:Are you sure you want to Delete?`,
      'Selected Count: ' + this.vm.list.filter(x => x.selected).length,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        // this.printActualCheckDocument();
        this.deleteSelected();
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  deleteSelected() {
    // just need to send the header id to the api
    const arrayOfItemsToDelete = [];
    this.vm.list.forEach((x) => {
      if (x.selected) {
        arrayOfItemsToDelete.push({header_id: x.id});
      }
    });

    if (!arrayOfItemsToDelete.length) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }
    // console.log('selected recs: ' + JSON.stringify(arrayOfItemsToDelete));

    // makes action button spinner turn while deleting
    this.isLoaded = false;
    // pass array as body in a delete to api entryController
    this.tableDataService.deleteDataByArray('entry', arrayOfItemsToDelete).pipe(take(1)).subscribe((item: any) => {
      if (item) {
        //  console.log(item);
        if (item.Message === 'Success') {
          this.isLoaded = true;
          this.getPagedApiData();
        }
      }
    });
  }

  hideBatches() {
    // this.vm.buttonsDisabled = true;
    this.vm.batchesHidden = !this.vm.batchesHidden;
    this.vm.Preferences.ShowBatches = !this.vm.batchesHidden;
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  navigateTo(id, print = false) {
    this.tableDataService.getData('entry/' + id).subscribe((result: any[]) => {
      // this.localStorage.StorageSet('paymentItem', JSON.stringify(result));
      this.router.navigateByUrl('/transactions/payment/form?paymentId=' + id + '&batchId=').then();
      if (print) {
        this.router
          .navigate(['/transactions/payment/form'], {queryParams: {paymentId: id, action: 'print'}})
          .then();
      } else {
        this.router.navigate(['/transactions/payment/form'], {queryParams: {paymentId: id}}).then();
      }
    });
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    this.isLoaded = false;
    this.vm.searching = true;
    // this.vm.batchId = '';
    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '5';
    } else {
      tempBatchType = '3';
    }
    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&batchId=' + (this.vm.batchId ? this.vm.batchId : '');
    paramString += '&search=' + (this.vm.paymentSearch ? this.vm.paymentSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.paymentFromDate ? this.dateFilter.GetDateFormat(this.vm.paymentFromDate) : '');
    paramString += '&toDate=' + (this.vm.paymentToDate ? this.dateFilter.GetDateFormat(this.vm.paymentToDate) : '');
    paramString += '&unappliedOnly=' + (this.vm.unappliedOnly === true ? 'true' : '');
    paramString += '&notPrintedOnly=' + (this.vm.notPrintedOnly === true ? 'true' : '');
    paramString += '&numberOfResults=' + (this.vm.paymentNumberOfResults ? this.vm.paymentNumberOfResults : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    // console.log('params: ' + paramString);
    // Debug: log outgoing GET for datatable
    console.log('[Payment List][GET] /api/PaymentList', {params: paramString});
    this.tableDataService.getApiListData('PaymentList', '?' + paramString).subscribe({
      next: (result2: ResponseModel) => {
        // Debug: log response summary and first row for field inspection
        try {
          const rows = (result2 as any)?.Data ?? (result2 as any)?.data ?? [];
          const total = (result2 as any)?.totalRecords ?? (result2 as any)?.TotalRecords ?? rows?.length ?? 0;
          console.log('[Payment List][GET return]', {count: Array.isArray(rows) ? rows.length : 0, totalRecords: total});
          if (Array.isArray(rows) && rows.length > 0) {
          }
        } catch {
        }
        this.vm.list = result2.Data;
        // console.log('list:' + JSON.stringify(this.vm.list));
        this.totalRecords = result2.totalRecords;
        this.paginate(false);
        // this.convertToNumbers();
        this.vm.searching = false;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error('Error fetching data:', err);
        this.vm.searching = false;
        this.isLoaded = false;
      },
      complete: () => {
        // console.log('Data fetch complete');
      }
    });
  }

  includeUnapplied(event: any = null) {
    if (event) {
      this.vm.unappliedOnly = true;
    } else {
      this.vm.unappliedOnly = false;
    }
    // this.vm.invoiceSearch = value.searchTerm;
    // this.vm.invoiceFromDate = value.fromDate;
    // this.vm.invoicetoDate = value.toDate;
    this.pageSize = this.appConfig.ListPageSize;
    this.page = 1;
    this.getPagedApiData();
  }

  getNotPrintedOnly(event: any = null) {
    if (event) {
      this.vm.notPrintedOnly = true;
    } else {
      this.vm.notPrintedOnly = false;
    }
    // this.vm.invoiceSearch = value.searchTerm;
    // this.vm.invoiceFromDate = value.fromDate;
    // this.vm.invoicetoDate = value.toDate;
    this.pageSize = this.appConfig.ListPageSize;
    this.page = 1;
    this.getPagedApiData();
  }

  serverSearch(value) {
    this.vm.paymentSearch = value.searchTerm;
    this.vm.paymentFromDate = value.fromDate;
    this.vm.paymentToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.paymentSearch = value.searchTerm;
    this.vm.paymentFromDate = value.fromDate;
    this.vm.paymentToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }



  isStripePaymentNotCompleted(row: any): boolean {
    if (this.vm.subLedger === 'ap') {
      return false;
    }
    const stripeStatus = row?.stripe_status ?? row?.stripeStatus ?? row?.StripeStatus ?? null;
    const stripeIntentId = row?.stripe_payment_intent_id ?? row?.stripePaymentIntentId ?? row?.StripePaymentIntentId ?? null;
    const stripeMethodId = row?.stripe_payment_method_id ?? row?.stripePaymentMethodId ?? row?.StripePaymentMethodId ?? null;
    const stripeTransactionId = row?.stripe_transaction_id ?? row?.stripeTransactionId ?? row?.StripeTransactionId ?? null;

    if (!stripeStatus) {
      return !!(stripeIntentId || stripeMethodId || stripeTransactionId);
    }

    const normalized = String(stripeStatus).toLowerCase().trim();
    if (!normalized) {
      return !!(stripeIntentId || stripeMethodId || stripeTransactionId);
    }

    return normalized !== 'succeeded' && normalized !== 'complete' && normalized !== 'completed';
  }


  protected readonly Number = Number;
}
